import React from "react";
import { useAtom } from "jotai";
import { darkThemeAtom } from "../../atoms";

import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Typography from "@material-ui/core/Typography";
import { MYCOLORS } from "../../mypallette";
import Grid from "@material-ui/core/Grid";
import { useProjectStyles } from "./ProjectStyles";

import ProjectCardKaura from "./ProjectCardKaura";
import ProjectCardSandwich from "./ProjectCardSandwich";

//import CountDown from "../5CountDown/CountDown"; not being used

const Projects = () => {
  const [darkTheme] = useAtom(darkThemeAtom);

  const classes = useProjectStyles();

  return (
    <>
      <Card elevation={4} className={darkTheme ? classes.cardmainDark : classes.cardmainLight}>
        <CardHeader
          title={
            <Typography
              align='center'
              variant='h4'
              style={{ color: darkTheme ? MYCOLORS.dhighlight : MYCOLORS.lhighlight }}
            >
              Projects
            </Typography>
          }
        ></CardHeader>
        <div style={{ visibility: "hidden", margin: 20 }}>invisble div</div>
        <>
          <Grid container spacing={8} wrap={"wrap"} direction='column' alignItems='center'>
            {/* <Grid item>
              <ProjectCard
                classes={styles4}
                title={"Come back soon to see completed projects!"}
                subtitle={"When? January 13, 2022"}
                image={comebacksoon}
              />
            </Grid> */}

            <Grid item>
              <ProjectCardKaura />
            </Grid>

            <Grid item>
              <ProjectCardSandwich />
            </Grid>

          </Grid>
        </>
        <div style={{ visibility: "hidden", margin: 20 }}>invisble div</div>
      </Card>
    </>
  );
};

export default Projects;
